var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5DAE0",
    d: "M9.523 1.99c.185.238.227.559.108.837a5.833 5.833 0 0 0 7.437 7.742.833.833 0 0 1 1.113.937 8.333 8.333 0 1 1-9.442-9.83.833.833 0 0 1 .784.314M7.637 3.679a6.667 6.667 0 1 0 8.499 8.848 7.5 7.5 0 0 1-8.499-8.848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/dark.a99e7b4ae6ff8b2804dc785fa4a9f22e.svg";
export { ForwardRef as ReactComponent };